// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { AbortError } from "@azure/abort-controller";
/**
 * Creates an abortable promise.
 * @param buildPromise - A function that takes the resolve and reject functions as parameters.
 * @param options - The options for the abortable promise.
 * @returns A promise that can be aborted.
 */

export function createAbortablePromise(buildPromise, options) {
  var _ref = options !== null && options !== void 0 ? options : {},
      cleanupBeforeAbort = _ref.cleanupBeforeAbort,
      abortSignal = _ref.abortSignal,
      abortErrorMsg = _ref.abortErrorMsg;

  return new Promise(function (resolve, reject) {
    function rejectOnAbort() {
      reject(new AbortError(abortErrorMsg !== null && abortErrorMsg !== void 0 ? abortErrorMsg : "The operation was aborted."));
    }

    function removeListeners() {
      abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.removeEventListener("abort", onAbort);
    }

    function onAbort() {
      cleanupBeforeAbort === null || cleanupBeforeAbort === void 0 ? void 0 : cleanupBeforeAbort();
      removeListeners();
      rejectOnAbort();
    }

    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
      return rejectOnAbort();
    }

    try {
      buildPromise(function (x) {
        removeListeners();
        resolve(x);
      }, function (x) {
        removeListeners();
        reject(x);
      });
    } catch (err) {
      reject(err);
    }

    abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.addEventListener("abort", onAbort);
  });
}